import { useState, useEffect } from 'react'
import { TabView, TabPanel } from 'primereact/tabview'
import { Dialog } from 'primereact/dialog'
import { Button } from 'primereact/button'
import { InputSwitch, InputSwitchChangeParams } from 'primereact/inputswitch'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

// local imports
import './NotificationModal.scss'
import warningImage from 'assets/images/warning-image.svg'
import loaderLogo from 'assets/icons/loading-filter.png'
import { MailSettingRequest } from 'types/MailSetting'
import AuthUtil from 'utils/AuthUtil'
import MailSettingService from 'service/MailSettingService'
import CampusService, { ICampusServiceExists } from 'service/CampusService'
import Loader from '../Loader'

export default function NotificationModal(props: { visible: any; setVisible: any; close: any; isManager: boolean }) {
  const employee = AuthUtil.getEmployeeSummary()

  const { t } = useTranslation()
  const [data, setData] = useState<MailSettingRequest>()
  const [btnControl, setBtnControl] = useState<boolean>(true)
  const [displayDialog, setDisplayDialog] = useState<boolean>(false)
  const [selectedTab, setSelectedTab] = useState<number>(0)
  const [showLoader, setShowLoader] = useState(false)
  const [hasCampusPlan, setHasCampusPlan] = useState<boolean>(false)
  const [campusVisible, setCampusVisible] = useState<ICampusServiceExists | undefined>()

  /* Get - Set Notification settings */
  useEffect(() => {
    const getNotification = () => {
      setShowLoader(true)
      MailSettingService.getMailSetting()
        .then((response) => setData(response.data))
        .catch((e) => console.log(e))
        .finally(() => setShowLoader(false))
    }
    const getCampusServiceExistss = () => {
      setShowLoader(true)
      CampusService.getCampusServiceExists()
        .then((r) => setCampusVisible(r.data))
        .catch((err) => console.log(err))
        .finally(() => setShowLoader(false))
    }
    if (employee) setHasCampusPlan(AuthUtil.hasCampus(employee?.exemptionSpecList!))
    getNotification()
    getCampusServiceExistss()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const {
    isAnyExist,
    isCoiffeurServiceExist,
    isGymServiceExist,
    isHealthServiceExist,
    isLactationServiceExist,
    isParkAreaServiceExist,
    isMeetingServiceExist,
    isPoolVehicleServiceExist,
  } = campusVisible || {}

  const hasHealth = AuthUtil.hasHealth(employee?.exemptionSpecList!)
  const hasGym = AuthUtil.hasGym(employee?.exemptionSpecList!)
  const hasCoiffeur = AuthUtil.hasCoiffeur(employee?.exemptionSpecList!)
  const hasLactation = AuthUtil.hasLactation(employee?.exemptionSpecList!)
  const hasMeeting = AuthUtil.hasMeeting(employee?.exemptionSpecList!)
  const hasParkArea = AuthUtil.hasParkArea(employee?.exemptionSpecList!)
  const hasPoolVehicle = AuthUtil.hasPoolVehicle(employee?.exemptionSpecList!)

  const saveNotificationSettings = () => {
    if (data) {
      MailSettingService.updateSaveMailSetting(data)
        .then((_r) => props.setVisible(false))
        .catch((e) => console.log(e))
    }
  }

  /* Switch Change handler */
  function handleSwitchChange(e: InputSwitchChangeParams) {
    if (!!btnControl) setBtnControl(false)
    setData((prev) => ({ ...prev, [e.target.name]: e.value }))
  }

  /* Confirmation Dialog */
  const renderConfirmFooter = () => {
    return (
      <div className="d-flex flex-row of-confirm-footer">
        <Button label={t('buttons.no')} onClick={onHide} className="p-button-outlined w-100" />
        <Button label={t('buttons.yes')} onClick={saveNotificationSettings} className="w-100 of-button-primary" />
      </div>
    )
  }
  const onHide = () => setDisplayDialog(false)
  const confirmDialogUI = () => {
    return (
      <Dialog
        header=""
        visible={displayDialog}
        position={'center'}
        modal
        style={{ width: '400px' }}
        footer={renderConfirmFooter()}
        onHide={onHide}
        draggable={false}
        resizable={false}>
        <div className="d-flex flex-column of-newplan-confirm-dialog">
          <div className="of-confirm-image">
            <img src={warningImage} alt="" />
          </div>
          <div className="">
            <p className="of-confirm-info mt-2">{t('overlaypanel-texts.notification-confirm-header')}</p>
          </div>
          <div className="of-confirm-detail">
            <p>{t('overlaypanel-texts.notification-confirm-text')}</p>
          </div>
        </div>
      </Dialog>
    )
  }

  const renderFooter = () => {
    return (
      <div className="col-12" style={{ display: 'flex', flexFlow: 'wrap', justifyContent: 'center' }}>
        <Button
          label={t('buttons.apply-selection')}
          disabled={btnControl}
          onClick={() => setDisplayDialog(true)}
          className="btnMail"
        />
      </div>
    )
  }

  const workNotifications = [
    {
      title: 'profile.content.notification-settings.firms-office-notification-mail',
      name: 'reservationMyFirmOffice',
      data: data?.reservationMyFirmOffice,
    },
    {
      title: 'profile.content.notification-settings.shared-office-mail',
      name: 'reservationSharedOffice',
      data: data?.reservationSharedOffice,
    },
    {
      title: 'profile.content.notification-settings.remote-office-mail',
      name: 'reservationHomeOffice',
      data: data?.reservationHomeOffice,
    },
  ]

  const campusNotifications = [
    isHealthServiceExist && hasHealth
      ? {
          title: 'profile.content.notification-settings.campus-health-mail',
          name: 'reservationHealt',
          data: data?.reservationHealt,
        }
      : null,
    isGymServiceExist && hasGym
      ? {
          title: 'profile.content.notification-settings.campus-gym-mail',
          name: 'reservationGymSaloon',
          data: data?.reservationGymSaloon,
        }
      : null,
    isCoiffeurServiceExist && hasCoiffeur
      ? {
          title: 'profile.content.notification-settings.campus-coiffeur-mail',
          name: 'reservationCoiffeur',
          data: data?.reservationCoiffeur,
        }
      : null,
    isLactationServiceExist && hasLactation
      ? {
          title: 'profile.content.notification-settings.campus-lactation-mail',
          name: 'reservationLactation',
          data: data?.reservationLactation,
        }
      : null,
    isParkAreaServiceExist && hasParkArea
      ? {
          title: 'profile.content.notification-settings.campus-park-area-mail',
          name: 'reservationPark',
          data: data?.reservationPark,
        }
      : null,
    isMeetingServiceExist && hasMeeting
      ? {
          title: 'profile.content.notification-settings.campus-meeting-room-mail',
          name: 'reservationMeetingRoom',
          data: data?.reservationMeetingRoom,
        }
      : null,
    isPoolVehicleServiceExist && hasPoolVehicle
      ? {
          title: 'profile.content.notification-settings.campus-pool-vehicle-mail',
          name: 'reservationPoolVehicle',
          data: data?.reservationPoolVehicle,
        }
      : null,
  ].filter(Boolean)

  const shouldRenderComponent =
    !!campusVisible &&
    isAnyExist &&
    (hasCampusPlan || isParkAreaServiceExist || isMeetingServiceExist || isPoolVehicleServiceExist)

  return (
    <>
      <Dialog
        blockScroll
        draggable={false}
        header={t('profile.menu-items.notification-settings')}
        visible={props.visible}
        style={{ width: '480px', height: '525px' }}
        footer={renderFooter()}
        onHide={props.close}>
        {showLoader ? (
          <Loader src={loaderLogo} />
        ) : (
          <TabWrapper>
            <TabView activeIndex={selectedTab} onTabChange={(e) => setSelectedTab(e.index)}>
              <TabPanel header={t('overlaypanel-texts.work-tab')}>
                {workNotifications.map((wn) => (
                  <ListWrapper key={wn.name}>
                    <div className="title">{t(wn.title)}</div>
                    <div className="switchbtn">
                      <InputSwitch name={wn.name} checked={wn.data} onChange={handleSwitchChange} />
                    </div>
                  </ListWrapper>
                ))}
              </TabPanel>

              {/* Campus Notifications */}
              {shouldRenderComponent && (
                <TabPanel header={t('overlaypanel-texts.campus-tab')}>
                  {campusNotifications?.map((cn) => (
                    <ListWrapper key={cn?.name} className="campus-services">
                      <div className="title">{t(cn?.title || '')}</div>
                      <div className="switchbtn">
                        <InputSwitch name={cn?.name} checked={cn?.data} onChange={handleSwitchChange} />
                      </div>
                    </ListWrapper>
                  ))}
                </TabPanel>
              )}
            </TabView>
          </TabWrapper>
        )}
      </Dialog>

      {confirmDialogUI()}
    </>
  )
}

const ListWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  &.campus-services {
    margin-bottom: 0.5rem;
  }
  .title {
    flex: 1 0 auto;
    line-height: 35px;
  }
  .switchbtn {
    display: flex;
    align-items: center;
    padding: 0 1rem;
  }
`
const TabWrapper = styled.div`
  .p-tabview-nav-container {
    margin-bottom: 0 !important;
  }
`
